import React, { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  Box,
  Typography,
  Button,
  Avatar,
  Slide,
  IconButton,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

// ─── Mensajes para ADMINISTRADOR ───────────────────────────────────────────────
const MENSAJES_ADMIN = [
  {
    titulo: "¡Bienvenido(a), líder!",
    cuerpo: `Hoy no solo inicias una jornada de trabajo… hoy lideras resultados, inspiras equipos y construyes el rumbo de toda una organización.

Cada decisión que tomes, cada estrategia que impulses y cada persona que motives tiene el poder de transformar desafíos en oportunidades.

Recuerda: un gran líder no solo dirige tareas, crea confianza, impulsa crecimiento y deja huella en cada acción.

Este portal es más que una herramienta; es el punto de partida para coordinar, innovar y alcanzar nuevas metas.

Que este día esté lleno de claridad, enfoque y resultados extraordinarios. ¡Tu liderazgo hace la diferencia!`,
  },
  {
    titulo: "Hoy defines el rumbo.",
    cuerpo: `El liderazgo no es sobre ser el mejor. Es sobre hacer mejores a los demás.

Un gran administrador construye equipos sólidos, traza visiones claras y convierte los obstáculos en escalones hacia el éxito.

Hoy tienes en tus manos el poder de cambiar el rumbo. Úsalo con sabiduría, con empatía y con determinación. ¡El equipo te espera!`,
  },
  {
    titulo: "Administrar es crear el futuro.",
    cuerpo: `"La gerencia es hacer las cosas correctamente; el liderazgo es hacer las cosas correctas." — Peter Drucker

Este día enfócate en lo que realmente mueve la aguja: las decisiones que impulsan al equipo, generan confianza y crean impacto duradero.

Tus acciones de hoy son los cimientos del éxito de mañana. ¡Vamos con todo!`,
  },
  {
    titulo: "Conoce el camino. Muéstralo.",
    cuerpo: `"Un líder es alguien que conoce el camino, lo recorre y lo muestra." — John C. Maxwell

Tu dirección y tu ejemplo son el mapa que guía a todo tu equipo. Cuando actúas con integridad y propósito, los demás te siguen de forma natural.

Hoy sé esa brújula que orienta, motiva y transforma. ¡El equipo confía en ti!`,
  },
  {
    titulo: "El estándar lo defines tú.",
    cuerpo: `"La calidad de un líder se refleja en los estándares que se impone a sí mismo." — Ray Kroc

Comienza este día con el nivel de excelencia más alto posible. Tu equipo observa cada acción, cada actitud y cada decisión.

Eleva el listón hoy y todos lo alcanzarán. La excelencia es contagiosa cuando viene desde arriba. ¡Tú marcas la pauta!`,
  },
  {
    titulo: "Tu equipo refleja tu liderazgo.",
    cuerpo: `"Los líderes sobresalientes elevan la autoestima de su equipo. Cuando las personas creen en sí mismas, es increíble lo que pueden lograr." — Sam Walton

Hoy tienes ese poder: con una palabra de aliento, con reconocer el esfuerzo, con crear un ambiente donde cada persona quiera dar lo mejor de sí.

Invierte en las personas de tu equipo. Es el retorno más alto que existe. ¡Empecemos!`,
  },
  {
    titulo: "Liderazgo y aprendizaje van de la mano.",
    cuerpo: `"El liderazgo y el aprendizaje son indispensables el uno del otro." — John F. Kennedy

Cada desafío de hoy es una lección disfrazada. Cada problema que resuelves amplía tu capacidad de liderazgo.

Mantente abierto(a), adapta tu estrategia y lidera con mayor fuerza que ayer. El mejor líder siempre está aprendiendo. ¡Hoy es un gran día para crecer!`,
  },
  {
    titulo: "Tus valores guían tus decisiones.",
    cuerpo: `"Cuando tus valores son claros para ti, tomar decisiones se vuelve más fácil." — Roy E. Disney

Antes de comenzar, define tus prioridades del día. Cuando actúas desde tus valores, cada decisión tiene propósito y cada acción genera confianza.

Hoy, permite que tu integridad sea la base de todo lo que construyes. ¡Que sea un día de decisiones poderosas!`,
  },
  {
    titulo: "No busques el consenso. Moldéalo.",
    cuerpo: `"Los líderes genuinos no buscan el consenso, lo moldean." — Martin Luther King Jr.

Hoy das forma al futuro de tu organización con cada interacción, cada reunión y cada decisión que tomas.

Actúa con convicción, escucha con humildad y lidera con visión. Transforma lo ordinario en extraordinario. ¡El momento es ahora!`,
  },
  {
    titulo: "Visión + Acción = Transformación.",
    cuerpo: `"La visión sin acción es solo un sueño. La acción sin visión es perder el tiempo. La visión con acción puede cambiar el mundo." — Joel A. Barker

Como administrador, hoy combina tu visión estratégica con acciones concretas y medibles.

No esperes el momento perfecto. Actúa con claridad, corrige en el camino y construye resultados que trasciendan. ¡El cambio empieza contigo hoy!`,
  },
  {
    titulo: "Liderar es servir.",
    cuerpo: `"El mejor líder es aquel del que la gente apenas sabe que existe. Cuando termina su trabajo y su objetivo se cumple, la gente dice: lo hicimos nosotros mismos." — Lao Tzu

El verdadero liderazgo no necesita reconocimiento constante. Se mide en los logros del equipo, en el crecimiento de las personas y en los resultados que perduran.

Hoy trabaja desde las sombras si es necesario, pero ilumina el camino de tu equipo. ¡Eso es liderazgo de alto impacto!`,
  },
  {
    titulo: "Hoy lideras resultados.",
    cuerpo: `Bienvenido(a). Hoy no solo inicias una jornada de trabajo… hoy lideras resultados, inspiras equipos y construyes el rumbo de toda una organización.`,
  },
  {
    titulo: "Cada decisión transforma.",
    cuerpo: `Cada decisión que tomes, cada estrategia que impulses y cada persona que motives tiene el poder de transformar desafíos en oportunidades.`,
  },
  {
    titulo: "Más que dirigir tareas.",
    cuerpo: `Recuerda: un gran líder no solo dirige tareas, crea confianza, impulsa crecimiento y deja huella en cada acción.`,
  },
  {
    titulo: "El punto de partida.",
    cuerpo: `Este portal es más que una herramienta; es el punto de partida para coordinar, innovar y alcanzar nuevas metas.`,
  },
  {
    titulo: "¡Vamos por un gran día!",
    cuerpo: `Que este día esté lleno de claridad, enfoque y resultados extraordinarios.

Tu liderazgo hace la diferencia. ¡Vamos por un gran día!`,
  },
];

// ─── Mensajes para COLABORADOR ─────────────────────────────────────────────────
const MENSAJES_COLABORADOR = [
  {
    titulo: "¡Bienvenido(a)!",
    cuerpo: `Cada día es una nueva oportunidad para crecer, conectar y superar tus propias metas.

Tu esfuerzo diario tiene un impacto real: cada llamada, cada visita, cada atención y cada acción ayudan a construir experiencias, confianza y éxito.

Nunca subestimes el valor de tu trabajo. La constancia, la actitud y la pasión son las herramientas que convierten un día común en un gran logro.

Recuerda: las metas grandes se alcanzan paso a paso, y cada acción cuenta. ¡Prepárate para dar lo mejor de ti y que tengas un día productivo, exitoso y lleno de oportunidades!`,
  },
  {
    titulo: "Pequeños pasos, grandes logros.",
    cuerpo: `"El éxito es la suma de pequeños esfuerzos repetidos día tras día." — Robert Collier

Cada acción que realizas hoy, por pequeña que parezca, se acumula y construye resultados extraordinarios.

Tu constancia es tu superpoder. No necesitas hacer todo perfecto; solo necesitas seguir avanzando. ¡Hoy es un buen día para sumar otro paso hacia tus metas!`,
  },
  {
    titulo: "Lo extraordinario está en el 'extra'.",
    cuerpo: `"La diferencia entre lo ordinario y lo extraordinario es ese pequeño 'extra'." — Jimmy Johnson

Hoy tienes la oportunidad de dar ese paso adicional que marca la diferencia: un poco más de atención, un poco más de cuidado, un poco más de energía.

Ese 'extra' es lo que te distingue y lo que construye una carrera brillante. ¿Estás listo(a) para ser extraordinario(a) hoy?`,
  },
  {
    titulo: "Juntos llegamos más lejos.",
    cuerpo: `"El trabajo en equipo es el combustible que permite a personas comunes alcanzar resultados extraordinarios." — Andrew Carnegie

Tu energía, tu actitud y tu colaboración son piezas fundamentales de este equipo. Cuando cada quien da lo mejor de sí, los resultados superan todas las expectativas.

Hoy pon ese motor a máxima potencia. ¡Tu equipo te necesita y tú los necesitas a ellos!`,
  },
  {
    titulo: "Haz que cada día cuente.",
    cuerpo: `"No cuentes los días, haz que los días cuenten." — Muhammad Ali

Este día es una página en blanco esperando tu historia. Cada tarea que completes, cada cliente que atiendas, cada meta que alcances es parte de esa historia de éxito.

¿Qué capítulo escribirás hoy? Hazlo memorable. Hazlo con propósito. ¡El tiempo es tu recurso más valioso!`,
  },
  {
    titulo: "Encuentra el propósito en cada acción.",
    cuerpo: `"La única manera de hacer un gran trabajo es amar lo que haces." — Steve Jobs

Cuando encuentras significado en lo que haces, el trabajo deja de ser una carga y se convierte en una fuente de energía y satisfacción.

Hoy busca ese propósito en cada tarea, en cada interacción, en cada resultado. Cuando trabajas con pasión, la excelencia es natural. ¡Vamos con toda la energía!`,
  },
  {
    titulo: "Los ganadores encuentran el camino.",
    cuerpo: `"Los ganadores encuentran maneras de ganar; los perdedores encuentran excusas para perder." — Harvey Mackay

Tú eres un(a) ganador(a). Cada obstáculo de hoy es una oportunidad disfrazada esperando ser descubierta por alguien con tu mentalidad.

No te enfoques en el problema; enfócate en la solución. No busques excusas; busca el camino. ¡Hoy encuentras ese camino!`,
  },
  {
    titulo: "La persistencia te lleva al éxito.",
    cuerpo: `"La persistencia es el camino al éxito." — Charlie Chaplin

No todo saldrá perfecto hoy, y eso está bien. Cada dificultad que superas te hace más fuerte, más hábil y mejor preparado(a) para lo que viene.

La clave no es no caer, sino levantarse cada vez con más determinación. Sigue adelante, mantén el ritmo y no te rindas. ¡Tu momento llega para quien persiste!`,
  },
  {
    titulo: "Tus metas tienen fecha.",
    cuerpo: `"Las metas son sueños con fecha límite." — Diana Scharf

Comienza el día con claridad sobre lo que quieres lograr. Escríbelo, visualízalo y actúa con determinación.

Cada tarea completada hoy es un paso concreto hacia esa meta. No esperes a sentirte listo(a); actúa y el impulso llegará solo. ¡Hoy avanzas hacia lo que quieres!`,
  },
  {
    titulo: "Tu trabajo importa más de lo que crees.",
    cuerpo: `"El cliente no es un interrumpido en tu trabajo, es el propósito de él." — Mahatma Gandhi

Cada persona que atiendes, cada servicio que brindas y cada problema que resuelves crea una experiencia real que construye confianza, lealtad y reputación.

Tu trabajo tiene un impacto directo en la vida de las personas. Hazlo con orgullo, con cuidado y con la convicción de que lo que haces importa. ¡Hoy importa mucho!`,
  },
  {
    titulo: "El coraje de continuar te define.",
    cuerpo: `"El éxito no es final, el fracaso no es fatal: es el coraje para continuar lo que cuenta." — Winston Churchill

Sin importar los altibajos del camino, tu valor para seguir adelante cada día es lo que define tu trayectoria profesional.

Los mejores resultados no llegan de la noche a la mañana; llegan de la suma de días como hoy, donde elegiste avanzar. ¡Hoy es uno de esos días decisivos!`,
  },
  {
    titulo: "¡Bienvenido(a)!",
    cuerpo: `Cada día es una nueva oportunidad para crecer, conectar y superar tus propias metas.`,
  },
  {
    titulo: "Tu esfuerzo tiene impacto real.",
    cuerpo: `Tu esfuerzo diario tiene un impacto real: cada llamada, cada visita, cada atención y cada venta ayudan a construir experiencias, confianza y éxito.`,
  },
  {
    titulo: "No subestimes tu trabajo.",
    cuerpo: `Nunca subestimes el valor de tu trabajo. La constancia, la actitud y la pasión son las herramientas que convierten un día común en un gran logro.`,
  },
  {
    titulo: "Avanza paso a paso.",
    cuerpo: `Hoy es momento de avanzar con energía, disciplina y mentalidad ganadora.

Recuerda: las metas grandes se alcanzan paso a paso, y cada acción cuenta.`,
  },
  {
    titulo: "¡Que tengas un gran día!",
    cuerpo: `Prepárate para dar lo mejor de ti.

¡Que tengas un día productivo, exitoso y lleno de oportunidades!`,
  },
];

// ─── Componente principal ───────────────────────────────────────────────────────
const SESSION_KEY = "welcome_popup_shown";

const WelcomePopup = ({ userRol, userName, cambiarPassword }) => {
  const [open, setOpen] = useState(false);
  const [mensaje, setMensaje] = useState(null);

  useEffect(() => {
    // Primer acceso con contraseña temporal → no mostrar
    if (cambiarPassword) return;
    if (sessionStorage.getItem(SESSION_KEY)) return;

    const pool =
      userRol === "administrador" || userRol === "admin"
        ? MENSAJES_ADMIN
        : MENSAJES_COLABORADOR;

    const random = pool[Math.floor(Math.random() * pool.length)];
    setMensaje(random);
    setOpen(true);
    sessionStorage.setItem(SESSION_KEY, "1");
  }, [userRol, cambiarPassword]);

  const handleClose = () => setOpen(false);

  if (!mensaje) return null;

  const isAdmin = userRol === "administrador" || userRol === "admin";
  const gradiente = isAdmin
    ? "linear-gradient(135deg, #0a0e27 0%, #1a1f3a 100%)"
    : "linear-gradient(135deg, #0d1117 0%, #0f2027 100%)";
  const accentColor = isAdmin ? "#00C9FF" : "#92FE9D";
  const accentEnd = isAdmin ? "#92FE9D" : "#00C9FF";

  const inicial =
    userName?.charAt(0)?.toUpperCase() || (isAdmin ? "A" : "C");

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      TransitionComponent={Transition}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          background: gradiente,
          border: `1px solid ${accentColor}30`,
          borderRadius: 4,
          boxShadow: `0 0 60px ${accentColor}25, 0 24px 48px rgba(0,0,0,0.6)`,
          overflow: "hidden",
        },
      }}
    >
      {/* Barra superior decorativa */}
      <Box
        sx={{
          height: 4,
          background: `linear-gradient(90deg, ${accentColor}, ${accentEnd})`,
        }}
      />

      <DialogContent sx={{ p: 0 }}>
        {/* Encabezado */}
        <Box
          sx={{
            px: 3,
            pt: 3,
            pb: 2,
            display: "flex",
            alignItems: "center",
            gap: 2,
            borderBottom: `1px solid rgba(255,255,255,0.07)`,
          }}
        >
          <Avatar
            sx={{
              width: 56,
              height: 56,
              fontSize: 24,
              fontWeight: 700,
              background: `linear-gradient(135deg, ${accentColor} 0%, ${accentEnd} 100%)`,
              color: "#000",
              flexShrink: 0,
            }}
          >
            {inicial}
          </Avatar>

          <Box sx={{ flex: 1 }}>
            <Typography
              sx={{
                fontWeight: 800,
                fontSize: "1.25rem",
                color: "#fff",
                lineHeight: 1.2,
              }}
            >
              {mensaje.titulo}
            </Typography>
            {userName && (
              <Typography
                sx={{ fontSize: "0.85rem", color: accentColor, mt: 0.3 }}
              >
                {userName}
              </Typography>
            )}
          </Box>

          <IconButton
            onClick={handleClose}
            size="small"
            sx={{ color: "rgba(255,255,255,0.4)", alignSelf: "flex-start" }}
          >
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        {/* Cuerpo del mensaje */}
        <Box sx={{ px: 3, py: 2.5, maxHeight: "55vh", overflowY: "auto" }}>
          {mensaje.cuerpo.split("\n\n").map((parrafo, idx) => (
            <Typography
              key={idx}
              variant="body2"
              sx={{
                color: "rgba(255,255,255,0.82)",
                lineHeight: 1.8,
                mb: 1.5,
                fontSize: "0.93rem",
              }}
            >
              {parrafo}
            </Typography>
          ))}
        </Box>

        {/* Pie con botón */}
        <Box
          sx={{
            px: 3,
            pb: 3,
            pt: 1,
            display: "flex",
            justifyContent: "flex-end",
          }}
        >
          <Button
            onClick={handleClose}
            variant="contained"
            sx={{
              background: `linear-gradient(90deg, ${accentColor}, ${accentEnd})`,
              color: "#000",
              fontWeight: 700,
              borderRadius: "50px",
              px: 4,
              textTransform: "none",
              fontSize: "0.95rem",
              boxShadow: `0 4px 20px ${accentColor}40`,
              "&:hover": {
                opacity: 0.9,
                boxShadow: `0 6px 28px ${accentColor}60`,
              },
            }}
          >
            ¡Comenzar mi día!
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default WelcomePopup;
